module.exports = __webpack_public_path__ + "static/media/1.bc9c5508.png";